import { Col, Row } from 'reactstrap';
import React from 'react';

import { IPendingTimesheetState } from './pending-timesheets.component';
import logo from 'styles/ciro_client_light.png';
import NoTimesheets from './no-timesheets-row.component';
import TimesheetRows from './timesheet-rows.component';

import 'features/pending-timesheets/styles/pending-timesheets-mobile.scss';
import NoParamMessage from './no-param-message.component';

const renderMobile = ({
    approvalModal,
    currentHeaderHeight,
    error,
    hospitalName,
    isApproveDisabled,
    isLoading,
    payPeriod,
    payPeriodStart,
    payPeriodEnd,
    selectAll,
    selectedTimesheetCount,
    setShowApproveModal,
    SHOW_MOCK_DATA,
    timesheets,
    toggleSelectAllRows,
    userRequestedMockData,
}: IPendingTimesheetState): JSX.Element => {
    let timesheetRows = null;
    let hasTimesheets = false;
    let appMessaging = null;

    if (isLoading) {
        appMessaging = <NoTimesheets />;
    } else if ((!SHOW_MOCK_DATA || !userRequestedMockData) && !timesheets?.length) {
        appMessaging = <NoParamMessage />;
    } else if (error?.message) {
        appMessaging = <NoTimesheets message={'Unable to retrieve timesheets'} />;
    } else {
        hasTimesheets = true;
        timesheetRows = (
            <div className={'mobile__body'} style={{ paddingTop: currentHeaderHeight }}>
                <TimesheetRows
                    {...{
                        payPeriodStart,
                        payPeriodEnd,
                        timesheets,
                    }}
                />
            </div>
        );
    }

    return (
        <div className="mobile-timesheet-table timesheet-table">
            <div className="tt-header">
                <Row className="logo">
                    <Col className="d-flex justify-content-center align-items-start">
                        <img src={logo} alt="ciro client" />
                    </Col>
                </Row>

                {timesheets?.length ? (
                    <>
                        <Row className="title-row">
                            <Col className="hospital-name" colSpan={4}>
                                {hospitalName || ''}
                            </Col>
                            <Col className="title-column" colSpan={4}>
                                {payPeriod ? `Pay period: ${payPeriod}` : ''}
                            </Col>
                        </Row>

                        <Row className="total-timesheets">
                            <Col>
                                <h1>{timesheets?.length} Timesheets</h1>
                            </Col>
                            <Col className={'select-all-button'}>
                                <button type="button" className="btn btn-link" onClick={() => toggleSelectAllRows()}>
                                    {selectAll ? 'Unselect All' : 'Select All'}
                                </button>
                            </Col>
                        </Row>
                    </>
                ) : null}
            </div>

            {hasTimesheets && (
                <p className="sr-only" role="alert">
                    Please note: You must select at least one timesheet to approve.
                </p>
            )}

            {appMessaging}

            {timesheetRows}

            {hasTimesheets && (
                <footer className="mobile__footer footer footer--shadow theme-green">
                    <div className="d-flex flex-row justify-content-center">
                        <button
                            onClick={() => setShowApproveModal(true)}
                            className="btn btn-me btn-primary d-block d-md-inline-block hover-highlight rounded-pill stretched-link submit-button"
                            disabled={isApproveDisabled}
                        >
                            Approve {selectedTimesheetCount ? selectedTimesheetCount + ' Timesheets' : ''}
                            <span className="sr-only"> Selected timesheets (Opens a popup)</span>
                        </button>
                    </div>
                </footer>
            )}

            {approvalModal}
        </div>
    );
};

export default renderMobile;
